import type { AuditEntry } from "@models/access";

/** Target fields core records, most specific first: the first present names the target. */
const TARGET_FIELDS: Array<[field: string, type: string]> = [
  ["userId", "user"],
  ["roleId", "role"],
  ["planId", "plan"],
  ["organisationId", "organisation"],
  ["applicationId", "application"],
];

/** The entry's main target: its type, id and (when core resolved it) name. */
export const auditTarget = (entry: AuditEntry): { type: string; id: string; name: string | null } => {
  for (const [field, type] of TARGET_FIELDS) {
    const id = entry.target[field];
    if (typeof id === "string" && id) return { type, id, name: entry.targetNames[field] ?? null };
  }
  return { type: "-", id: "-", name: null };
};

export const auditActor = (entry: AuditEntry): string => entry.actorName ?? entry.actorId ?? "-";
